<template>
  <div v-if="car">
    <teleport to="#crentCarDetailHeadline"
      ><span v-html="car.text_web"></span
    ></teleport>
    <teleport to="#crentCarDetailSubline"
      ><span v-html="car.description_web"></span
    ></teleport>
    <teleport to="#crentCarDetailBodytext"
      ><span v-html="car.category_text"></span
    ></teleport>
    <teleport to="#crentCarDetailEquipment">
      <EquipIcon :data="car.features" />
    </teleport>
    <teleport to="#crentCarDetailImages"
      ><Slider v-if="car.images" :images="car.images" />
    </teleport>
    <teleport to="#crentCarDetailPriceMonthly"
      ><CalcPrice :car="car" no-wrapper @settarif="getTarif($event)" />
    </teleport>
    <teleport to="#crentCarDetailReservatebutton" v-if="tarif"
      ><button class="orm-btn orm-btn--outline" @click="select(car)">
        {{ i18n("modules/carcategory/button") }}
      </button>
    </teleport>
  </div>
</template>
<script>
import store from "@/store";

import { slugMe } from "@/constants/formater";
import Slider from "@/components/ui/image-slider.vue";
import EquipIcon from "@/components/reservation/equip-icon.vue";
import CalcPrice from "@/components/ui/slider/calcPrice.vue";
import i18n from "@/mixins/mixins";

export default {
  props: ["name"],
  mixins: [i18n],
  components: { EquipIcon, Slider, CalcPrice },
  data() {
    return {
      car: null,
      stations: null,
      slugMe,
      tarif: null,
      type: "headline",
    };
  },
  async mounted() {
    await store.dispatch("cargroup/SET_CARGROUPS_ALL");
    this.init();
    // if (store.getters["cargroup/GET_GLOBAL_CARGROUPS"].length > 0) {
    //   this.init();
    // } else {

    // }
    // store.watch(
    //   (state, getters) => getters["cargroup/GET_GLOBAL_CARGROUPS"],
    //   () => {
    //     if (store.getters["cargroup/GET_GLOBAL_CARGROUPS"].length > 0) {

    //     }
    //   }
    // );
  },
  methods: {
    async init() {
      const carGroup = await store.getters["cargroup/GET_GLOBAL_CARGROUPS"];
      let selectedcarcategory = null;
      if (document.getElementById("crentReservation")) {
        selectedcarcategory = document.getElementById("crentReservation")
          .dataset.vehicleid;
      }

      this.car = carGroup.find((element) => element.id == selectedcarcategory);
    },
    getTarif(tarif) {
      this.tarif = tarif;
    },
    select(car) {
      store.dispatch("userSession/SET_CARGROUP", car.id).then(() => {
        store
          .dispatch("reservation/SET_RESERVATION_TARIFS", this.tarif)
          .then(() => {
            window.location.href =
              process.env.VUE_APP_BASE_URL +
              process.env.VUE_APP_RESERVATION_PATH +
              process.env.VUE_APP_RESERVATION_PATH_STEP2;
          });
      });
    },
  },
};
</script>
